import { createReducer } from './create';

const initialState = {
    is_loading_packages: false,
    has_loaded_packages: false,
    packages_by_month: [],
    show_empty_dates: false,
    total_tickets: 0,
    total_ticket_available: 0,
};

export default createReducer(initialState, {
    ['PACKAGES/LOAD']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_packages: true,
        });
    },
    ['PACKAGES/LOAD_FINISHED']: (state, payload) => {
        let totalTickets = 0;
        let totalTicketsAvailable = 0;

        for (let i = 0; i < payload.packages.length; ++i) {
            let data = payload.packages[i].data;
            for (let x = 0; x < data.length; ++x) {

            }
        }

        for (let i = 0, l = payload.packages.length, month; i < l; ++i) {
            month = payload.packages[i];
            for (let j = 0, ll = month.data.length; j < ll; ++j) {
                totalTickets = totalTickets + 1;
                if (month.data[j].available) {
                    totalTicketsAvailable++;
                }
            }
        }

        return Object.assign({}, state, {
            is_loading_packages: false,
            has_loaded_packages: true,
            total_tickets: totalTickets,
            packages_by_month: payload.packages || [],
            total_ticket_available: totalTicketsAvailable,
        });
    },
});
